import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.shipmentView.shipmentStatusSection.title',
    defaultMessage: 'Status',
    description: 'title of the status section',
  },
  shipmentStatusSection: {
    overview: {
      isEditable: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isEditable',
        defaultMessage: 'Editable',
        description: 'title of the is editable in the shipment method section',
      },
      isOutbound: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isOutbound',
        defaultMessage: 'Outbound',
        description: 'title of the is outbound in the shipment method section',
      },
      isListed: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isListed',
        defaultMessage: 'Listed',
        description: 'title of the is listed in the shipment method section',
      },
      isBoxed: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isBoxed',
        defaultMessage: 'Boxed',
        description: 'title of the is boxed in the shipment method section',
      },
      handlingListStatus: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.handlingListStatus',
        defaultMessage: 'List status',
        description: 'title of the is listed in the shipment method section',
      },
      isFinished: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isFinished',
        defaultMessage: 'Finished',
        description: 'title of the is finished in the shipment method section',
      },
      isInTransit: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isInTransit',
        defaultMessage: 'In transit',
        description: 'title of the is in transit in the shipment method section',
      },
      isDelivered: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isDelivered',
        defaultMessage: 'Delivered',
        description: 'title of the is delivered in the shipment method section',
      },
      isLabeled: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isLabeled',
        defaultMessage: 'Shipment label',
        description: 'title of the is labeled in the shipment method section',
      },
      isComplete: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isComplete',
        defaultMessage: 'Complete',
        description: 'title of the is complete in the shipment method section',
      },
      isOvercomplete: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isOvercomplete',
        defaultMessage: 'Overcomplete',
        description: 'title of the is overcomplete in the shipment method section',
      },
      isCancelled: {
        id: 'pages.shipmentView.shipmentStatusSection.overview.isCancelled',
        defaultMessage: 'Cancelled',
        description: 'title of the is cancelled in the shipment method section',
      },
    },
  },
};

export default defineMessages(translations);
